import { Home, Exercise, Reward, Trophy, Event, Calendar, Day, Union, PendingApproval, OrganizationManagement, UserManagement, DidimHw, Contents, Championship, EventManagement, NoticeAndPush, GeneralManagement } from '../../assets/images';

// Configuration constants
export const RootPathName = 'Didim';
export const Type = 'Drawer'; //AppBar, Drawer
export const drawerMaxWidth = 248;
export const drawerMinWidth = 56;
export const isDrawerOpen = true;

// Menu definitions
export const SupervisorDefinition = [
    {
        name: 'pending_approval',
        path: '/applications',
        icon: PendingApproval,
        subMenus: [
            { name: 'organization_application_list', path: '/applications' },
            { name: 'organization_application_list', path: '/applications/list' },
            { name: 'organization_application_detail', path: '/applications/detail' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'organization_management',
        path: '/organizations',
        icon: OrganizationManagement,
        subMenus: [
            { name: 'organization_list', path: '/organizations' },
            { name: 'organization_list', path: '/organizations/list' },
            { name: 'organization_detail', path: '/organizations/detail' },
        ],
    },
    {
        name: 'user_management',
        path: '/users',
        icon: UserManagement,
        subMenus: [
            { name: 'user_list', path: '/users' },
            { name: 'user_list', path: '/users/list' },
            { name: 'user_detail', path: '/users/detail' },
            { name: 'user_add_edit', path: '/users/edit' },
            { name: 'my_page', path: '/users/mypage' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'didim_h_w',
        path: '/didims',
        icon: DidimHw,
        subMenus: [
            { name: 'didim_h_w_list', path: '/didims' },
            { name: 'didim_h_w_list', path: '/didims/list' },
            { name: 'didim_h_w_edit', path: '/didims/edit' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'contents',
        path: '/contents',
        icon: Contents,
        subMenus: [
            { name: 'contents_list', path: '/contents' },
            { name: 'contents_list', path: '/contents/list' },
            { name: 'contents_add_edit', path: '/contents/edit' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'championship',
        path: '/championships',
        icon: Championship,
        subMenus: [
            { name: 'championship_list', path: '/championships' },
            { name: 'championship_list', path: '/championships/admin' },
            { name: 'add_championship', path: '/championships/admin-add' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'event_management',
        path: '/events',
        icon: EventManagement,
        subMenus: [
            { name: 'event_list', path: '/events' },
            { name: 'event_list', path: '/events/admin' },
            { name: 'event_detail', path: '/events/admin-detail' },
            { name: 'event_add_edit', path: '/events/edit' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'notice_and_push',
        path: '/notices',
        icon: NoticeAndPush,
        subMenus: [
            { name: 'notice_list', path: '/notices' },
            { name: 'notice_list', path: '/notices/admin' },
            { name: 'notice_list', path: '/notices/notice-list' },
            { name: 'notice_detail', path: '/notices/notice-detail' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'general_management',
        path: '/generals',
        icon: GeneralManagement,
        subMenus: [
            { name: 'general_admin_list', path: '/generals/list' },
            { name: 'admin_add_edit', path: '/generals/edit' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'user_management',
        path: '/users',
        icon: UserManagement,
        subMenus: [
            { name: 'my_page', path: '/users/mypage' },
            { name: 'information_edit', path: '/users/mypage-edit' },
            { name: 'language_settings', path: '/users/language' },
            { name: 'exp', path: '/users/exp' },
            { name: ' ', path: '/users/qr' },
            { name: 'organization_membership_list', path: '/users/membership', rightSection: 'unregister' },
            { name: 'push_notification_settings', path: '/users/push' },
        ],
        leftSection: 'back',
        rightSection: '',
        hidden: true, // 메뉴에서 숨김
    },
];

export const SupervisorGeneralDefinition = [
    {
        name: 'pending_approval',
        path: '/applications',
        icon: PendingApproval,
        subMenus: [
            { name: 'organization_application_list', path: '/applications' },
            { name: 'organization_application_list', path: '/applications/list' },
            { name: 'organization_application_detail', path: '/applications/detail' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'organization_management',
        path: '/organizations',
        icon: OrganizationManagement,
        subMenus: [
            { name: 'organization_list', path: '/organizations' },
            { name: 'organization_list', path: '/organizations/list' },
            { name: 'organization_detail', path: '/organizations/detail' },
        ],
    },
    {
        name: 'user_management',
        path: '/users',
        icon: UserManagement,
        subMenus: [
            { name: 'user_list', path: '/users' },
            { name: 'user_list', path: '/users/list' },
            { name: 'user_detail', path: '/users/detail' },
            { name: 'user_add_edit', path: '/users/edit' },
            { name: 'my_page', path: '/users/mypage' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'didim_h_w',
        path: '/didims',
        icon: DidimHw,
        subMenus: [
            { name: 'didim_h_w_list', path: '/didims' },
            { name: 'didim_h_w_list', path: '/didims/list' },
            { name: 'didim_h_w_edit', path: '/didims/edit' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'contents',
        path: '/contents',
        icon: Contents,
        subMenus: [
            { name: 'contents_list', path: '/contents' },
            { name: 'contents_list', path: '/contents/list' },
            { name: 'contents_add_edit', path: '/contents/edit' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'championship',
        path: '/championships',
        icon: Championship,
        subMenus: [
            { name: 'championship_list', path: '/championships' },
            { name: 'championship_list', path: '/championships/admin' },
            { name: 'add_championship', path: '/championships/admin-add' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'event_management',
        path: '/events',
        icon: EventManagement,
        subMenus: [
            { name: 'event_list', path: '/events' },
            { name: 'event_list', path: '/events/admin' },
            { name: 'event_detail', path: '/events/admin-detail' },
            { name: 'event_add_edit', path: '/events/edit' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'notices_and_push',
        path: '/notices',
        icon: NoticeAndPush,
        subMenus: [
            { name: 'notice_list', path: '/notices' },
            { name: 'notice_list', path: '/notices/admin' },
            { name: 'notice_list', path: '/notices/notice-list' },
            { name: 'notice_detail', path: '/notices/notice-detail' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'user_management',
        path: '/users',
        icon: UserManagement,
        subMenus: [
            { name: 'my_page', path: '/users/mypage' },
            { name: 'information_edit', path: '/users/mypage-edit' },
            { name: 'language_settings', path: '/users/language' },
            { name: 'exp', path: '/users/exp' },
            { name: ' ', path: '/users/qr' },
            { name: 'organization_membership_list', path: '/users/membership', rightSection: 'unregister' },
            { name: 'push_notification_settings', path: '/users/push' },
        ],
        leftSection: 'back',
        rightSection: '',
        hidden: true, // 메뉴에서 숨김
    },
];

export const AdminDefinition = [
    {
        name: 'organization_management',
        path: '/organizations/detail',
        icon: OrganizationManagement,
        textType: '',
        rightSection: 'alarm',
    },
    {
        name: 'user_management',
        path: '/users',
        icon: UserManagement,
        subMenus: [
            { name: 'user_list', path: '/users' },
            { name: 'user_detail', path: '/users/detail' },
            { name: 'user_edit', path: '/users/edit' },
            { name: 'my_page', path: '/users/mypage' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'didim_h_w',
        path: '/didims',
        icon: DidimHw,
        subMenus: [
            { name: 'didim_list', path: '/didims' },
            { name: 'didim_edit', path: '/didims/edit' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'championship',
        path: '/championships',
        icon: Championship,
        subMenus: [
            { name: 'championship_admin', path: '/championships' },
            { name: 'add_championship', path: '/championships/admin-add' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'notice_and_push',
        path: '/notices',
        icon: NoticeAndPush,
        subMenus: [
            { name: 'notice_list', path: '/notices' },
            { name: 'notice_list', path: '/notices/admin' },
            { name: 'notice_list', path: '/notices/notice-list' },
            { name: 'notice_detail', path: '/notices/notice-detail' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'general_management',
        path: '/generals',
        icon: GeneralManagement,
        subMenus: [
            { name: 'general_admin_list', path: '/generals/list' },
            { name: 'admin_add_edit', path: '/generals/edit' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'user_management',
        path: '/users',
        icon: UserManagement,
        subMenus: [
            { name: 'my_page', path: '/users/mypage' },
            { name: 'information_edit', path: '/users/mypage-edit' },
            { name: 'language_settings', path: '/users/language' },
            { name: 'exp', path: '/users/exp' },
            { name: ' ', path: '/users/qr' },
            { name: 'organization_membership_list', path: '/users/membership', rightSection: 'unregister' },
            { name: 'push_notification_settings', path: '/users/push' },
        ],
        leftSection: 'back',
        rightSection: '',
        hidden: true, // 메뉴에서 숨김
    },
];

export const AdminGeneralDefinition = [
    {
        name: 'organization_management',
        path: '/organizations/detail',
        icon: OrganizationManagement,
        textType: '',
        rightSection: 'alarm',
    },
    {
        name: 'user_management',
        path: '/users',
        icon: UserManagement,
        subMenus: [
            { name: 'user_list', path: '/users' },
            { name: 'user_detail', path: '/users/detail' },
            { name: 'user_edit', path: '/users/edit' },
            { name: 'my_page', path: '/users/mypage' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'didim_h_w',
        path: '/didims',
        icon: DidimHw,
        subMenus: [
            { name: 'didim_list', path: '/didims' },
            { name: 'didim_edit', path: '/didims/edit' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'championship',
        path: '/championships',
        icon: Championship,
        subMenus: [
            { name: 'championship_admin', path: '/championships' },
            { name: 'add_championship', path: '/championships/admin-add' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'notice_and_push',
        path: '/notices',
        icon: NoticeAndPush,
        subMenus: [
            { name: 'notice_list', path: '/notices' },
            { name: 'notice_list', path: '/notices/admin' },
            { name: 'notice_list', path: '/notices/notice-list' },
            { name: 'notice_detail', path: '/notices/notice-detail' },
        ],
        textType: '',
        rightSection: '',
    },
    {
        name: 'user_management',
        path: '/users',
        icon: UserManagement,
        subMenus: [
            { name: 'my_page', path: '/users/mypage' },
            { name: 'information_edit', path: '/users/mypage-edit' },
            { name: 'language_settings', path: '/users/language' },
            { name: 'exp', path: '/users/exp' },
            { name: ' ', path: '/users/qr' },
            { name: 'organization_membership_list', path: '/users/membership', rightSection: 'unregister' },
            { name: 'push_notification_settings', path: '/users/push' },
        ],
        leftSection: 'back',
        rightSection: '',
        hidden: true, // 메뉴에서 숨김
    },
];

export const AdminGeneralApplyDefinition = [
    {
        name: 'organization_register',
        path: '/applications/detail',
        subMenus: [
            { name: 'organization_application_status', path: '/applications/detail' },
        ],
        textType: '',
        rightSection: 'alarm',
    }
];

export const UserDefinition = [
    {
        name: 'home',
        path: '/',
        icon: Home,
        textType: 'logo',
        rightSection: ['qrCode', 'alarm'],
    },
    {
        name: 'exercise_report',
        path: '/reports',
        icon: Exercise,
        subMenus: [
            { name: 'daily_activity', path: '/reports/activity', customRightIcon: Calendar, onRightIconClickPath: '/reports/activity-monthly' },
            { name: 'monthly_report', path: '/reports/activity-monthly', customRightIcon: Day, onRightIconClickPath: '/reports/activity', hidden: true, leftSection: 'back' },
            { name: 'step_count', path: '/reports/step', customRightIcon: Union, onRightIconClickPath: '/reports/step-union' },
            { name: 'step_count', path: '/reports/step-union', hidden: true, leftSection: 'back' },
            { name: 'heart_rate', path: '/reports/heartbeat', customRightIcon: Union, onRightIconClickPath: '/reports/heartbeat-union' },
            { name: 'heart_rate', path: '/reports/heartbeat-union', hidden: true, leftSection: 'back' },
            { name: 'didim_exercise_report', path: '/reports/didim', customRightIcon: Calendar, onRightIconClickPath: '/reports/didim-monthly' },
            { name: 'didim_exercise_report', path: '/reports/didim-monthly', customRightIcon: Day, onRightIconClickPath: '/reports/didim', hidden: true, leftSection: 'back' },
        ],
        textType: 'title',
        rightSection: '',
    },
    {
        name: 'reward',
        path: '/rewards',
        icon: Reward,
        subMenus: [
            { name: 'challenge_status', path: '/rewards/challenge' },
            {
                name: 'reward_history',
                path: '/rewards/history',
                /**
                 * location.state가 이 객체와 전부 일치하면 모바일 헤더 좌측을 백으로 (그 외·메뉴 진입은 햄버거).
                 * 진입 시: navigate(path, { state: { rewardHistoryFromMypage: true } }) 등과 키/값을 맞출 것.
                 */
                leftSectionWhenStateMatches: { rewardHistoryFromMypage: true },
            },
            // { name: 'application', path: '/rewards/application' },
        ],
        textType: 'title',
        rightSection: 'refresh',
    },
    {
        name: 'championship',
        path: '/championships',
        icon: Trophy,
        textType: '',
        rightSection: '',
    },
    // {
    //     name: 'menu_settings',
    //     path: '/settings',
    //     icon: Setting,
    //     textType: 'title',
    //     rightSection: 'refresh',
    // },
    {
        name: 'user_management',
        path: '/users',
        subMenus: [
            { name: 'my_page', path: '/users/mypage' },
            { name: 'information_edit', path: '/users/mypage-edit' },
            { name: 'exp', path: '/users/exp' },
            { name: ' ', path: '/users/qr' },
            { name: 'organization_membership_list', path: '/users/membership', rightSection: 'unregister' },
            { name: 'push_notification_settings', path: '/users/push' },
        ],
        textType: 'title',
        leftSection: 'back',
        rightSection: '',
        hidden: true, // 메뉴에서 숨김
    },
    {
        name: 'notifications',
        path: '/notices',
        subMenus: [
            { name: 'notifications', path: '/notices/notification-list', leftSection: 'back' },
            { name: 'notices', path: '/notices/notice-list', leftSection: 'back' },
            { name: 'notice_detail', path: '/notices/notice-detail', leftSection: 'back' },
        ],
        textType: 'title',
        leftSection: 'back',
        rightSection: '',
        hidden: true, // 메뉴에서 숨김
    },
    {
        name: 'event',
        path: '/events',
        icon: Event,
        subMenus: [
            { name: 'event', path: '/events/user', hidden: true },
            { name: 'event_detail', path: '/events/user-detail', leftSection: 'back', hidden: true },
        ],
        textType: 'title',
        rightSection: 'refresh',
    },
];
